export * from './lottery-result-block-type.enum';
